<template>
  <IonPageContainer :scroll-y="scrollY" :show-pull-to-refresh="showPullToRefresh">
    <div
      class="page-container bg-color-light-translucent p-2 w-full mx-auto m:w-[90%] xl:w-[80%]"
      :class="fillHeight ? 'h-full flex flex-col' : 'min-h-full'"
    >
      <PageHeaderBar
        :pageTitle="pageTitle"
        :pageDescriptor="pageDescriptor"
        :closeTarget="closeTarget"
        class="mb-2"
        @on-close="$emit('onClose')"
      >
        <template v-if="$slots.actionButton" #actions>
          <slot name="actionButton" />
        </template>
        <template v-if="$slots.titleTrailing" #titleTrailing>
          <slot name="titleTrailing" />
        </template>
      </PageHeaderBar>
      <slot name="pageContent" />
    </div>
    <!-- Opt-in escape hatch for viewport-pinned chrome (fabs). Rendered as a sibling of
         `.page-container` so it lands as a direct child of IonContent — the only place
         Ionic honours `slot="fixed"`; inside `#pageContent` a fab would scroll away. -->
    <slot name="fixedContent" />
  </IonPageContainer>
</template>

<script lang="ts">
import AppPullToRefresh from "@/components/layout/AppPullToRefresh.vue";
import IonPageContainer from "@/components/layout/IonPageContainer.vue";
import PageHeaderBar from "@/components/layout/PageHeaderBar.vue";
import { CloseTargetType } from "@/types/componentType";
import { PropType, defineComponent } from "vue";

export default defineComponent({
  name: "IonPageTitleContainer",
  components: { PageHeaderBar, AppPullToRefresh, IonPageContainer },
  props: {
    pageTitle: { type: String, required: true },
    pageDescriptor: { type: String, required: true },
    scrollY: { type: Boolean, default: true },
    // Opt-in full-height layout: makes `.page-container` a bounded flex column so a slotted
    // view can own its own scroll region (`flex-1 min-h-0 overflow-y-auto`) with a fixed
    // header/footer. Requires `:scroll-y="false"` on the same call. Default off — normal
    // views keep `min-h-full` + native `ion-content` scroll.
    fillHeight: { type: Boolean, default: false },
    showPullToRefresh: { type: Boolean, default: true },
    closeTarget: { type: String as PropType<CloseTargetType>, default: "previous" },
  },
  emits: ["onClose"],
});
</script>
